import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AddressSharedServiceI,
  CitySharedServiceI,
} from '../../../../../interfaces/src/lib/interfaces/index';

export interface IAddressManagement {
  selectedCountry: string;
  addressData: AddressSharedServiceI[] | CitySharedServiceI[];
}

const initialState: IAddressManagement = {
  selectedCountry: '',
  addressData: [],
};

const addressInfoSlice = createSlice({
  name: 'addressManagement',
  initialState,
  reducers: {
    setAddressData: (state, action: PayloadAction<IAddressManagement['addressData']>) => {
      state.addressData = action.payload;

      return state;
    },
    setSelectedCountry: (state, action: PayloadAction<typeof state.selectedCountry>) => {
      if (state.selectedCountry !== action.payload) {
        state.selectedCountry = action.payload;
        state.addressData = [];
      }
      return state;
    },
  },
});

export const { setAddressData, setSelectedCountry } = addressInfoSlice.actions;
export default addressInfoSlice.reducer;
